/**
 * Created by JackCui on 2022/3/16
 */
import response from '../../../utils/response'
import api from './api'
import projectInfo from '../../../utils/project-info'

export default {
  digits: {
    methods: {
      async getDigits () {
        const projectMap = {
          'pur': api.purDigits,
          'sur': api.surDigits,
          'mall': api.mallDigits
        }
        const {type, url} = projectMap[projectInfo.query()] || api.purDigits
        const data = await response({
          method: type,
          url
        })
        if (data.isOk) {
          return {
            unitPriceDigits: data.content.unitPriceBit,
            numberDigits: data.content.unitNumber
          }
        }
      }
    }
  }
}
